const LEGACY_CODES = [
  {
    label: 'First Name',
    value: '{FIRST_NAME}',
    text: 'First Name will be replaced with recipients name',
  },
  {
    label: 'Last Name',
    value: '{LAST_NAME}',
    text: 'Last Name will be replaced with recipients name',
  },
  {
    label: 'Email',
    value: '{EMAIL}',
    text: 'Email will be replaced with recipients email',
  },
  {
    label: 'Mobile Phone',
    value: '{MOBILE_PHONE}',
    text: 'Mobile Number will be replaced by the recipients number',
  },
  {
    label: 'Address',
    value: '{ADDRESS_1} {CITY}, {STATE} {ZIP}',
    text: 'Address will be replaced by the recipients address',
  },
  {
    label: 'Contact Form',
    value: '{BASIC_UPD}',
    text: 'Contact Form will be replaced by the recipients contact form',
  },
  {
    label: 'Full Contact Form',
    value: '{EXTENDED_UPD}',
    text: 'Full Contact Form will be replaced by the recipients full contact form',
  },
  {
    label: 'Family Contact Form',
    value: '{FAMILY_DCC}',
    text: 'Family Contact Form will be replaced by the recipients family contact form',
  },
  {
    label: 'Smart Connect Card (SCC)',
    value: '{SMART_CC}',
    text: 'Smart Connect Card (SCC) will be replaced by the recipients smart connect card (SCC)',
  },
  {
    label: 'User Signature',
    value: '{USER_SIGNATURE}',
    text: 'User Signature will be replaced by the recipients user signature',
  },
];

export const DCC_MATCH =
  /{BASIC_UPD}|{EXTENDED_UPD}|{FAMILY_DCC}|{SMART_CC}|{WEBSITE}|{TWITTER}|{FACEBOOK}|{LINKEDIN}|{PODCAST}|{YOUTUBE}|{CUSTOM1}|{CUSTOM2}/;

export const CONTACT_SHORT_CODES = {
  '{FIRST_NAME}': 'First Name',
  '{LAST_NAME}': 'Last Name',
  '{EMAIL}': 'Email',
  '{MOBILE_PHONE}': 'Mobile Phone',
  '{ADDRESS_1}': 'Address Line 1',
  '{CITY}': 'City',
  '{STATE}': 'State',
  '{ZIP}': 'Zip',
};

export const MISC_SHORT_CODES = {
  '{USER_SIGNATURE}': 'User Signature',
  '{CC_LINK}': 'Connect Card',
};

export default LEGACY_CODES;
